/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
 
  CREATE_INSTRUCTIONS,
  CREATE_INSTRUCTIONS_SUCCESS,
  CREATE_INSTRUCTIONS_ERROR,

  LOAD_INSTRUCTIONS,
  LOAD_INSTRUCTIONS_SUCCESS,
  LOAD_INSTRUCTIONS_ERROR,

  UPDATE_INSTRUCTIONS,
  UPDATE_INSTRUCTIONS_SUCCESS,
  UPDATE_INSTRUCTIONS_ERROR,

  DELETE_INSTRUCTIONS,
  DELETE_INSTRUCTIONS_SUCCESS,
  DELETE_INSTRUCTIONS_ERROR,
} from "./constants"

//Special Instructions
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


export function loadInstructions(Id) {
  return {
    type: LOAD_INSTRUCTIONS,
    Id,
  }
}

export function loadInstructionsSuccess(quotation_preview) {
  return {
    type: LOAD_INSTRUCTIONS_SUCCESS,
    quotation_preview,
  }
}

/**
 * @param {string} error
 */

export function loadInstructionsError(error) {
  return {
    type: LOAD_INSTRUCTIONS_ERROR,
    error,
  }
}

export function createInstruction(specialInstructions) {
  console.log("record", specialInstructions)
  return {
    type: CREATE_INSTRUCTIONS,
    specialInstructions,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function createInstructionSuccess(specialInstructions, success) {
  console.log("record", specialInstructions)
  return {
    type: CREATE_INSTRUCTIONS_SUCCESS,
    specialInstructions,
    success,
  }
}

/**
 * @param {string} error
 */
export function createInstructionError(error) {
  return {
    type: CREATE_INSTRUCTIONS_ERROR,
    error,
  }
}

export function updateInstruction(specialInstructions) {
  return {
    type: UPDATE_INSTRUCTIONS,
    specialInstructions,
  }
}

/**
 *
 * @param {object} record
 * @param {string} success
 * @returns
 */
export function updateInstructionSuccess(specialInstructions, success) {
  return {
    type: UPDATE_INSTRUCTIONS_SUCCESS,
    specialInstructions,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateInstructionError(error) {
  return {
    type: UPDATE_INSTRUCTIONS_ERROR,
    error,
  }
}

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
export function deleteInstruction(id, instructionsId) {
  const leadId = id

  return {
    type: DELETE_INSTRUCTIONS,
    leadId,
    instructionsId,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteInstructionSuccess(id, instructionsId, success) {
  const leadId = id
  return {
    type: DELETE_INSTRUCTIONS_SUCCESS,
    leadId,
    instructionsId,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteInstructionError(error) {
  return {
    type: DELETE_INSTRUCTIONS_ERROR,
    error,
  }
}




const actions = {
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  createInstruction,
  createInstructionError,
  createInstructionSuccess,

  deleteInstruction,
  deleteInstructionSuccess,
  deleteInstructionError,

  updateInstructionError,
  updateInstruction,
  updateInstructionSuccess,

  loadInstructions,
  loadInstructionsSuccess,
  loadInstructionsError,

}

export default actions
